import { FlightDeckLoader, LOADER_CANVAS } from './vendor/FlightDeckLoader'

// A wait with nothing to show (Hotfix 053).
//
// WHY THIS EXISTS, with the measurement. Issuing an environment on ATC's HA-off
// Consumption plan took **13,000 ms** on a cold start (App Insights,
// 2026-09-10 15:14:39) and ~1,550 ms warm. The Issue button disabled itself and
// changed its label, and nothing else happened for thirteen seconds — which
// reads as a hung app, not as work in progress. `ATC-ADR-007` says the cold
// starts are "mitigated by operator-controlled onboarding cadence, not
// technically", so this wait is a permanent property of the deployed posture
// and the UI has to account for it.
//
// The loader's own guidance is to use it only where the wait plausibly reaches
// its 2.8s loop. Thirteen seconds does; a list refresh does not, which is why
// the lists keep their existing inline loading state instead.
export function PendingOverlay({ label }: { label: string }) {
  return (
    <div className="rx-pending" role="status" aria-live="polite">
      {/* The mark's negative space is hardcoded to LOADER_CANVAS, so the
          surface behind it must paint that exact colour or the resolve state
          renders with a visible seam. Named constant, not a magic hex. */}
      <div className="rx-pending-card" style={{ background: LOADER_CANVAS }}>
        <FlightDeckLoader size={72} label={label} />
        <p className="rx-pending-label">{label}</p>
        <p className="rx-pending-hint">
          First request after an idle period can take up to ~15 seconds while the service starts.
        </p>
      </div>
    </div>
  )
}
